// extracted by mini-css-extract-plugin
export default {"container":"ZgkFeYBjzXCxxHVtApbv","box":"niITmGLyzZkI3uOq3Usn","name":"BaDcfQoEWJCulJ6c1Ssb","value":"HeUCfwzpyDokKEH5pcVr"};